export enum EChartNameLocation {
    END = 'end',
    START = 'start',
    MIDDLE = 'middle'
}
